<template>
  <div class="page">
    <div class="flex-aligncol-center" style="margin-top: 200px">
      <img class="topic-icon" src="@/assets/topicIcon.png" />
      <div class="title-1" style="font-size: 22px; padding: 20px 0 30px 0">
        {{ queryRecord?.name }}
      </div>
      <div>
        <span class="tip">共{{ baseInfo?.allNum || 0 }}个测评</span>
        <span class="tip">题数：{{ baseInfo?.allTopicNum || 0 }}题</span>
        <span class="tip">预计用时：{{ baseInfo?.allTime || 0 }}分钟</span>
      </div>
      <div class="submit-text">已提交</div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { TOPIC_RECORD } from '@/store/mutation-types'

export default {
  name: 'SubmitAssessment',
  props: {
    baseArr: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      formData: {},
      baseInfo: {},
      queryRecord: {},
    }
  },
  watch: {
    baseArr: {
      handler(val) {
        if (!val.length) return
        const allNum = val.length
        const allTopicNum = val?.reduce((acc, cur) => acc + cur.num, 0)
        const allTime = val?.reduce((acc, cur) => {
          if (cur.time) {
            return acc + Number(cur.time.split('分钟')[0])
          }
        }, 0)
        this.baseInfo = {
          allNum,
          allTopicNum,
          allTime,
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.queryRecord = Vue.ls.get(TOPIC_RECORD)?.queryRecord || {}
  },
  methods: {
    setDefaultGrade(record) {
      this.$set(this.formData, 'gradeId', record[0].value)
      this.currGradeName = record[0].title
    },
    selectStuInfo(type, record) {},
    handleChange() {},
    submitStuInfo() {
      this.$emit('submitStuInfo', this.formData)
    },
  },
}
</script>
<style scoped lang="less">
.page {
  display: flex;
  justify-content: center;
  min-height: 90vh;
  background-color: #fff;
  border-radius: 10px;
}
.selet-stu {
  width: 220px;
  padding: 10px;
}
.topic-icon {
  width: 100px;
  height: 100px;
}
.tip {
  padding: 0 20px;
}
.submit-text {
  padding: 30px;
  font-size: 24px;
  color: #13b999;
  line-height: 24px;
}
</style>
